import { useEffect, useState } from 'react';
import { VideoJsPlayer } from 'video.js';
import { NextActionBarBtn, Timer } from '../styles';
import { Flex } from '../../../styles';
import { __t } from '../../../i18n';

const AdCounter = ({ player, hasVast }: { player: VideoJsPlayer; hasVast: (val: boolean) => void }) => {
  const [counter, setCounter] = useState<number | undefined>();

  // In an effect rather than the render body: registering on every render stacked up a new
  // set of listeners each time the counter ticked.
  useEffect(() => {
    const onShowAdCounter = (e) => {
      hasVast(true);
      setCounter(Math.round(e.counter));
    };
    const onComplete = () => {
      hasVast(false);
      setCounter(undefined);
    };
    const onSeeking = () => {
      setCounter(undefined);
      hasVast(false);
    };

    player.on('vast.showAdCounter', onShowAdCounter);
    // A mid-roll that comes back without an ad ("no fill", failed request) ends on an error.
    player.on(['vast.complete', 'vast.error'], onComplete);
    player.on('seeking', onSeeking);
    return () => {
      player.off('vast.showAdCounter', onShowAdCounter);
      player.off(['vast.complete', 'vast.error'], onComplete);
      player.off('seeking', onSeeking);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player]);

  return (
    <>
      {!!counter && <NextActionBarBtn>
        <Flex justify="center" align="center">
          <Timer>
            ({counter})
          </Timer>
          {__t('player.showing_ad')}
        </Flex>
      </NextActionBarBtn>}
    </>
  );
};

export default AdCounter;
